<div class="personal-info-complete-container">

  <img alt="personal info complete" src="/img/personal-info-complete.png">

  <div class="text header">
    <span [innerHTML]="'PersonalInfoComplete.First.Title' | translate | safe:'html'"></span>
  </div>

  <div [innerHTML]="'PersonalInfoComplete.First.SubTitle' | translate | safe:'html'" class="text">
  </div>

</div>
